import { timestamp } from "@/api/firebase/firebase.config";
import { useCurrentUserProfile } from "@/store/auth/userProfile.store";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import { useEffect, useState } from "react";
import { PrecisionGameLeaderboard } from "../models/precisionGame.types";
import { collectionRef } from "@/api/collectionRef/collectionOperations";
import { toast } from "react-toastify";
import i18next from "i18next";

const usePrecisionGameSubmit = (
  data: PrecisionGameLeaderboard,
  date: string
) => {
  const currentUser = useCurrentUserProfile((s) => s.user);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const [values, setValues] = useState<PrecisionGameLeaderboard>({
    attempts: data?.attempts || 0,
    score: data?.score || 0,
    uid: currentUser.uid,
    userName: currentUser.userName || "",
    created_at: timestamp.now(),
    id: data?.id || "",
  });

  useEffect(() => {
    if (data) {
      setValues({
        ...values,
        ...data,
      });
    }
  }, [data]);

  const submitScore = async (values) => {
    setLoading(true);
    setError(null);

    try {
      const ref = collectionRef.precisionGame(brand.tenantId, date);

      await ref
        .add({
          ...values,
          created_at: timestamp.now(),
        })
        .then(() => {
          // toast.success(i18next.t("precisionGame.toast.success"));
        })
        .catch((error) => {
          // toast.error(i18next.t("precisionGame.toast.error") + error.message);
        });

      setLoading(false);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return { submitScore, loading, error };
};

export default usePrecisionGameSubmit;
